import {generatePath} from './generate-path';
import {type PathGenerationArgs} from './path-generation-args';
import {type RouteConfigPath} from './route-config-path';

export type GenerateHashFunction = <T extends RouteConfigPath>(...args: PathGenerationArgs<T>) => string;

// Use this to directly generate a hash for any route that exists in the config
export const generateHash: GenerateHashFunction = <T extends RouteConfigPath>(...args: PathGenerationArgs<T>) =>
    `#${generatePath(args)}`;
